import React, { FC } from 'react'
import { observer } from 'mobx-react'
import { useTranslation } from 'react-i18next'
import kehilaMigrationWizardStore from 'store/kehilaMigrationWizard.store'
import orgs from 'store/orgs.store'
import { TextInput, RowSplit, PlainButton, Banner } from '../KehilaMigrationWizard.styles'

const hintStyle: React.CSSProperties = {
  color: '#101828',
  fontWeight: 400,
  fontSize: 13,
  lineHeight: '18px',
}

const ConnectStep: FC = () => {
  const store = kehilaMigrationWizardStore
  const { t } = useTranslation('kehilaMigration')

  return (
    <>
      <Banner kind='bad' style={{ fontWeight: 700, fontSize: 14, marginBottom: 16 }}>
        {t`connect_warning`}
      </Banner>
      {/* Make it explicit that this id is the SOURCE (KehilaNet) and where the
          data will land (the current Mekome community). Only the community
          name/number are emphasised. */}
      <div style={{ ...hintStyle, marginBottom: 6 }}>{t`connect_source_hint`}</div>
      <TextInput
        id='kehila-community-id'
        value={store.communityId}
        onChange={e => store.setCommunityId(e.target.value)}
        style={{ width: 150 }}
        inputMode='numeric'
      />
      <div style={{ ...hintStyle, marginTop: 6 }}>
        {t`connect_dest_prefix`}
        <strong>{(orgs.currentOrg as any)?.name ?? '—'}</strong>
        {t`connect_dest_number`}
        <strong>{orgs.currentOrgId ?? '—'}</strong>
      </div>
      <RowSplit style={{ marginTop: 14 }}>
        <PlainButton disabled={!store.communityId} onClick={store.testConnection}>
          {t`connect_testConnection`}
        </PlainButton>
      </RowSplit>
      {store.probed && store.connectionCounts ? (
        <Banner kind='ok'>
          {t('connect_reached', { categories: store.connectionCounts.categoriesCount, protocols: store.connectionCounts.protocolsCount })}
        </Banner>
      ) : store.connectionError ? (
        <Banner kind='bad'>{store.connectionError}</Banner>
      ) : (
        <Banner>{t`connect_hint`}</Banner>
      )}
    </>
  )
}

export default observer(ConnectStep)
